import React, { useEffect } from "react";
import logo from '../assets/images/cdm-logo.png';
import "./Header.css";

const Header = () => {
  useEffect(() => {
    var lastScrollTop = 0;
    const navbar = document.getElementById("navbar");
    window.addEventListener("scroll", function(){
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if(scrollTop > lastScrollTop) {
        navbar.style.top = "-150px";
      }
      else {
        navbar.style.top = "0px";
      }
      lastScrollTop = scrollTop;
    });
  }, []);
  return (
    <>
      <section className="header inter" id="navbar">
        <nav className="navbar navbar-expand-lg blue-bg shadow-sm">
          <div className="container">
            <a className="navbar-brand" href="index.html">
              <img src={logo} className="img-fluid" alt="Logo" />
            </a>
            <button className="navbar-toggler border-0" type="button" data-bs-toggle="offcanvas" data-bs-target="#mobileMenu" aria-controls="mobileMenu">
              <i className="hgi hgi-stroke hgi-rounded hgi-menu-11 text-white"></i>
            </button>
            <div className="collapse navbar-collapse d-none d-lg-block" id="navbarSupportedContent">
              <ul className="navbar-nav ms-auto">
                <li className="nav-item">
                  <a className="nav-link active" href="index.html">
                    Home
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="#about-us">
                    About Us
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="#services">
                    Services
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="#portfolio">
                    Portfolio
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="blog.html">
                    Blog
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="contact-us.html">
                    Contact Us
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </section>
      <div className="offcanvas offcanvas-star fira-sans" id="mobileMenu" aria-labelledby="mobileMenuLabel">
        <div className="offcanvas-header border-bottom">
          <a className="navbar-brand" href="index.html">
            <img src={logo} className="img-fluid w-50" alt="Logo"/>
          </a>
          <button type="button" className="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
        </div>
        <div className="offcanvas-body">
          <ul className="navbar-nav">
            <li className="nav-item">
              <a className="nav-link" href="index.html">
                Home
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#about-us">
                About Us
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#services">
                Services
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#portfolio">
                Portfolio
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="blog.html">
                Blog
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="contact-us.html">
                Contact Us
              </a>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default Header;
